import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { McdStateList } from '../mcdState/McdStateList';
import { ProgList } from '../prog/ProgList';
import { CtrtAmendmentList } from './CtrtAmendmentList';
import { CtrtForm } from './CtrtForm';

export const CtrtDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <CtrtForm /> },
    { id: 'prog', label: 'Programs', content: <ProgList key="progList" ctrtObj={entityObj} /> },
  ];

  if (entityObj.type === 'MCD') {
    tabSpecs.push({ id: 'state', label: 'States', content: <McdStateList ctrtObj={entityObj} /> });
  }

  tabSpecs.push(
    { id: 'entityProps', label: 'Properties', content: <EntityPropList parentEntity="CTRT" parentEntityObj={entityObj} />},
    { id: 'val', label: 'Validations', content: <ValList parentEntity="CTRT" parentEntityId={entityObj.id}/>},
  );

  if (entityObj.status === 'IMPL') {
    tabSpecs.push({ id: 'amendment', label: 'Amendments', content: <CtrtAmendmentList ctrtObj={entityObj} /> });
  }


  return (
    <EntityDetail entity="CTRT" tabSpecs={tabSpecs} />
  )
}